import draggable from './module/draggable'
import clipboard from './module/clipboard'
import permission from './module/permission'

const directives = {
  draggable,
  clipboard,
  permission
}

export default directives
